import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import SelectUsersMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/users-multi"
import Views_convertStatusesToStatusString from "../../functions/convert-statuses-to-string"
import Views_convertStatusStringToStatuses from "../../functions/convert-string-to-statuses"
import {SystemStatus} from "../../../gd/const/system-status"
import SelectProjectSystemStatus
    from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-system-status"
import SelectProjectTemplatesMulti
    from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-templates-multi"
import {EntityType} from "../../../gd/const/item"

type ProjectsListConditionsType = {
    templates               : ID[]
    projects                : ID[]
    users                   : ID[]
    systemProjectStatuses   : SystemStatus[]
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: ProjectsListConditionsType):void }
}

// const debug = "ViewProjectsList_Conditions"
const debug = false

export default function ViewProjectsList_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: ProjectsListConditionsType = {
            templates               : result.templates,
            projects                : result.projects,
            users                   : result.users,
            systemProjectStatuses   : Views_convertStatusStringToStatuses(result.systemProjectStatuses)
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const updateUsersField = (name: string, allUserIds: ID[]) => {
        const users = form.getValue(name);
        const newUsers = _.intersection(users, allUserIds)
        form.setFieldValue(name, newUsers)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)
        const newUsers = quickAdd_getUsersIds(projects)

        updateUsersField('users', newUsers)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        templates               : conditions?.templates || [],
        projects                : conditions?.projects || [],
        users                   : conditions?.users || [],
        systemProjectStatuses   : Views_convertStatusesToStatusString(conditions?.systemProjectStatuses),
    }

    const formStructure = {
        fields          : {
            templates               : { type: 'select',   isRequired: false,  label: 'Templates',               onUserChange: onUserChange},
            projects                : { type: 'select',   isRequired: false,  label: 'Projects'},
            users                   : { type: 'select',   isRequired: false,  label: 'Users',                   onUserChange: onUserChange},
            systemProjectStatuses   : { type: 'select',   isRequired: false,  label: 'System project statuses', onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData)
    const projectsIds = form.getValue('projects') || []
    const usersIds = quickAdd_getUsersIds(projectsIds)

    const classes = Classes("ui5-form", props.className)

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectTemplatesMulti form           = {form}
                                             formFieldName  = "templates"
                                             disabled       = {props.disabled}/>

                <SelectProjectMulti form            = {form}
                                    formFieldName   = 'projects'
                                    parentsFor      = {EntityType.PROJECT}
                                    disabled        = {props.disabled}
                                    onParentSelect  = {onParentSelect}/>

                <SelectUsersMulti label                 = "Users"
                                  form                  = {form}
                                  formFieldName         = 'users'
                                  usersIds              = {usersIds}
                                  includeCurrentUser    = {true}
                                  disabled              = {props.disabled}/>

                <SelectProjectSystemStatus form             = {form}
                                           formFieldName    = 'systemProjectStatuses'
                                           disabled         = {props.disabled}/>
            </div>
        </div>
    )
}